import React, { memo } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const TONES = ['neutral', 'progress', 'success', 'warn', 'danger'];

/**
 * Rounded status pill with an optional leading colored dot.
 * Used for assignment status, violations and similar table/list states.
 */
const StatusPill = ({ tone, withDot, children, ...rest }) => (
  <Styled.Pill tone={tone} {...rest}>
    {withDot && <Styled.Dot tone={tone} />}
    {children}
  </Styled.Pill>
);

StatusPill.propTypes = {
  tone: PropTypes.oneOf(TONES),
  withDot: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

StatusPill.defaultProps = {
  tone: 'neutral',
  withDot: true,
};

export default memo(StatusPill);
